import React from "react";
import ReactPaginate from "react-paginate";
import "./style.css";

const Pagination = ({ onChange, totalPageCount, currentPageNumber }) => {
  const handlePageClick = (event) => {
    onChange?.(event.selected);
  };
  // if (totalPageCount === 0 || totalPageCount === 1) {
  //   return null;
  // }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
      }}
    >
      <ReactPaginate
        activeClassName={"item active "}
        breakClassName={"item break-me "}
        breakLabel={"..."}
        forcePage={currentPageNumber}
        containerClassName={"pagination"}
        disabledClassName={"disabled-page"}
        marginPagesDisplayed={2}
        nextClassName={"item next "}
        nextLabel={"بعدی"}
        onPageChange={handlePageClick}
        pageCount={totalPageCount}
        pageClassName={"item pagination-page "}
        pageRangeDisplayed={2}
        previousClassName={"item previous"}
        previousLabel={"قبلی"}
      />
    </div>
  );
};

export default Pagination;
